/**
 * Подсветка target-элемента при scroll-to-anchor.
 *
 * Подписан на `ui-store.flashAnchor`. Когда якорь меняется на не-null —
 * находит DOM-элемент с этим id, добавляет CSS-класс `pflow-flash`,
 * через `FLASH_MS` снимает класс и обнуляет якорь в store.
 *
 * CSS-keyframes — в `index.css` (animation `pflow-flash-anim`).
 *
 * Размещён в RepoPage (один раз на страницу), не в каждом компоненте.
 */

import { useEffect } from 'react';
import { useUiStore } from '../stores/ui-store';

const FLASH_MS = 1500;

export function useFlashEffect(): void {
    const flashAnchor = useUiStore(s => s.flashAnchor);
    const clearFlash  = useUiStore(s => s.clearFlash);

    useEffect(() => {
        if (!flashAnchor) return;
        const el = document.getElementById(flashAnchor);
        if (!el) {
            clearFlash();
            return;
        }
        el.classList.add('pflow-flash');
        const timer = window.setTimeout(() => {
            el.classList.remove('pflow-flash');
            clearFlash();
        }, FLASH_MS);
        return () => {
            window.clearTimeout(timer);
            el.classList.remove('pflow-flash');
        };
    }, [flashAnchor, clearFlash]);
}
